import { Button } from '@mui/material';
import {
  contractTermsDateFormatter,
  globalContractTermsContent,
  globalContractTermsTitle,
} from '../../utils/contractsData';
import FullModal from '../Layout/FullModal';

const ContractTermsModal = ({ onClose }) => {
  const termsContent = globalContractTermsContent.replace(
    '{{effectiveDate}}',
    contractTermsDateFormatter.format(new Date())
  );

  return (
    <FullModal onClose={onClose}>
      <h3 className="confirm-modal__title contract-terms-modal__title">
        {globalContractTermsTitle}
      </h3>
      <div className="contract-terms-modal__content">
        {termsContent}
      </div>
      <div className="confirm-modal__actions">
        <Button variant="contained" onClick={onClose}>
          Agree
        </Button>
      </div>
    </FullModal>
  );
};

export default ContractTermsModal;
